import { memo, useCallback, useEffect, useState } from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { FactCheck } from '@mui/icons-material'
import EnvironmentalAndSafetyAssessmentForm from './EnvironmentalAndSafetyAssessmentForm'
import QualityAndFSAssessmentForm from './QualityAndFSAssessmentForm'
import Page from '../layout/Page'
import FormViewCommandBar from '../commandBar/FormViewCommandBar'
import { QUALITY_FS, ENV_SAFETY, titles } from '../utils/constants'
import { getToken } from '../auth/auth'
import { ApiGateway } from '../config/config'
import axios from 'axios'
import { calculateProgress, loadAssessmentItems } from './context/AssessmentContext'
import qfsModels from './models/QualityAndFSModels'
import envModels from './models/EnvironmentalAndSafetyModels'
import EventBus from '../utils/EventBus'

let itemsProgress = []

export default function EditAssessmentPage (props = {}) {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true)
  const location = useLocation()
  const { assessmentId, type } = useParams()
  const [assessment, setAssessment] = useState()
  const [progressAvailable, setProgressAvailable] = useState(false)
  const [activeCategoriesList, setActiveCategoriesList] = useState()

  const startLoading = useCallback(() => {
    setIsLoading(true)
  }, [])

  const stopLoading = useCallback(() => {
    setIsLoading(false)
  }, [])

  
  const publishProgress = useCallback((_itemsProgress) => {
    EventBus.emit('PROGRESS', _itemsProgress)
    // itemsProgressSubscribers.forEach((fn) => {
    //   fn(_itemsProgress)
    // })
  }, [])

  const setItemsList = useCallback((_list) => {
    const prog = [...qfsModels, ...envModels].reduce((p,m) => {
      const [a,b] = calculateProgress(m, _list)
      p.push(a, ...b)
      return p
    },[])
    itemsProgress = prog
    setProgressAvailable(true)
    publishProgress(prog)
  }, [publishProgress])

  const refreshItemList = useCallback(async () => {
    if (!assessment?.id) return
    const _itemsList = await loadAssessmentItems(assessment.id)
    setItemsList(_itemsList)
  }, [assessment?.id, setItemsList])
  // const itemsProgressSubscribers = []
  // const subscribeToProgress = (fn) => {
  //   console.log('subscribing')
  //   itemsProgressSubscribers.push(fn)
  // }
  

  const handleClose = () => {
    if (location.key === 'default') {
      navigate(`/my-assessments`)
    } else {
      navigate(-1)
    }
  }

  const defaultAssessmentType = ''

  const getAssessment = useCallback(async () => {
    startLoading()
    const token = await getToken()
    const requestConfig = {
      headers: {        
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token.idToken}`
      }
    }
    const basePath = `${ApiGateway.assessments}/${assessmentId}`
    const responses = await Promise.all([
      axios.get(basePath, requestConfig),
      loadAssessmentItems(assessmentId, requestConfig)
    ])
    const assessmentResponse = responses[0]
    const itemsResponse = responses[1]
    const result = assessmentResponse.data
    if (result) {
      const _assessment = structuredClone(result)
      delete _assessment.ManufacturerProfile
      setAssessment(_assessment)
      setItemsList(itemsResponse)
    }
    stopLoading()
  }, [assessmentId, setAssessment, setItemsList, startLoading, stopLoading])
  
  const breadcrumb = <div><span><FactCheck />&nbsp;{titles[type]}&nbsp;Assessment</span></div>

  const AssessmentForm = memo(function AssessmentForm({ assessment }) {    
    if (type === QUALITY_FS)
    return (<QualityAndFSAssessmentForm 
      assessment={assessment} 
      refreshItemList={refreshItemList} 
      progressItemsList={itemsProgress}
      // subscribeToProgress={subscribeToProgress}
      activeCategoriesList={activeCategoriesList}
      setActiveCategoriesList={setActiveCategoriesList}
      defaultAssessmentType={defaultAssessmentType}
      />)
    if (type === ENV_SAFETY)
    return (<EnvironmentalAndSafetyAssessmentForm 
      assessment={assessment} 
      refreshItemList={refreshItemList}
      progressItemsList={itemsProgress}
      // subscribeToProgress={subscribeToProgress}
      activeCategoriesList={activeCategoriesList}
      setActiveCategoriesList={setActiveCategoriesList}
      defaultAssessmentType={defaultAssessmentType}
      />)
  })

  useEffect(() => {
    getAssessment()
  }, [getAssessment])

  return (
      <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading} commandBar={
          <FormViewCommandBar onClose={handleClose} showCancel={false} showSave={false} />}> 
            { (assessment && progressAvailable) && 
              <AssessmentForm assessment={assessment} />
            }
        </Page>
  )
}